var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBubble(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 102,
    viewBox: "0 0 112 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.662 32.3046C63.0299 26.0696 49.535 10.4316 38.3389 21.9995C25.677 35.0819 27.5874 58.3165 36.4441 73.3322C44.486 86.9667 61.377 91.239 76.662 86.9734C91.8244 82.7419 104.887 70.4294 105.402 54.0356C105.838 40.1604 88.415 37.6801 76.662 32.3046Z",
    fill: "#FFF8E8",
    stroke: "#FF5F3D",
    strokeOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.7369 20.7284C51.8438 13.9167 37.1005 -3.16793 24.8687 9.47012C11.0356 23.7627 13.1227 49.1465 22.7987 65.5512C31.5845 80.447 50.038 85.1145 66.7369 80.4542C83.3019 75.8314 97.573 62.3799 98.1355 44.4697C98.6115 29.3109 79.5771 26.6012 66.7369 20.7284Z",
    stroke: "#FF5F3D",
    strokeOpacity: 0.5,
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBubble);
export default __webpack_public_path__ + "static/media/bubble.a3c543b8694936c3e270c33fb10d5aa2.svg";
export { ForwardRef as ReactComponent };